module.exports = __webpack_public_path__ + "static/media/faceit.76faa79f.svg";